import { Download } from "@mui/icons-material";
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import policyService from "../../services/policyService";

const PolicyTemplateTable = (props) => {
	
	const handleRowClick = (template) => {
		policyService.downloadTemplate(template);
	};

	return (
		<Box sx={{width: "100%", margin: "auto"}}>
			<TableContainer component={Paper} sx={{ width: "100%" }}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ textAlign: "left", width: "75%" }}>Name</TableCell>
							<TableCell sx={{ textAlign: "center", width: "10%" }}>Type</TableCell>
							<TableCell sx={{ textAlign: "center", width: "10%" }}>Category</TableCell>
							<TableCell sx={{ textAlign: "center", width: "5%" }}></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{policyService.templates? policyService.templates.map((template) => (
						<TableRow key={`template_${template.name}`}>
							<TableCell sx={{ textAlign: "left" }}>
								<Button
									onClick={() => { handleRowClick(template) }}
									sx={{ width: "100%", justifyContent: "flex-start" }}
								>
									{`${template.name}`}
								</Button>
							</TableCell>
							<TableCell sx={{ textAlign: "center" }}>{template.type}</TableCell>
							<TableCell sx={{ textAlign: "center" }}>{template.category}</TableCell>
							<TableCell sx={{ textAlign: "center" }}>
								<Button
									onClick={() => { handleRowClick(template) }}
									sx={{ width: "100%", justifyContent: "center" }}
								>
									<Download/>
								</Button>
							</TableCell>
						</TableRow>
						)):<TableRow></TableRow>}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	)
}

export default PolicyTemplateTable;